import { render, staticRenderFns } from "./WaterBill.vue?vue&type=template&id=6c05bdc8&scoped=true"
import script from "./WaterBill.vue?vue&type=script&lang=js"
export * from "./WaterBill.vue?vue&type=script&lang=js"
import style0 from "./WaterBill.vue?vue&type=style&index=0&id=6c05bdc8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c05bdc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c05bdc8')) {
      api.createRecord('6c05bdc8', component.options)
    } else {
      api.reload('6c05bdc8', component.options)
    }
    module.hot.accept("./WaterBill.vue?vue&type=template&id=6c05bdc8&scoped=true", function () {
      api.rerender('6c05bdc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/WaterBill.vue"
export default component.exports